import { EndpointFramePipe } from './endpointPipe';
import type { WorkerTransport } from './types';

/**
 * `new Worker(url, { type: 'module' })`, frames over the worker's own port. Each connect()
 * spawns; pipe disposal terminates the worker.
 */
export const dedicatedWorkerTransport = (spawn: () => Worker): WorkerTransport => ({
    connect: () => {
        const worker = spawn();
        return new EndpointFramePipe({
            postMessage: (data) => worker.postMessage(data),
            messageTarget: worker,
            errorTarget: worker,
            teardown: () => worker.terminate(),
        });
    },
});
